import { Plugins } from '@leverege/plugin';
import { AttributeDetailModel } from '@leverege/ui-attributes';
import StringUtil from '@leverege/string-util';

/**
 * This create details for the Relationships
 */
const install = opts => {
  let detailCreatorOnChange = null;
  const dirty = evt => {
    // Fire a change to the detail creator mechanism
    // when attributes are added/removed
    if (detailCreatorOnChange) {
      detailCreatorOnChange();
    }
  };
  Plugins.on('Attribute', dirty);
  // Add a Plugin to convert Attributes into Details
  Plugins.add('DetailCreator', {
    name: 'RelationshipDetailCreator',
    onChange: cb => {
      detailCreatorOnChange = cb;
    },
    create: () => {
      const plgs = Plugins.get('Attribute');
      const details = [];
      plgs.forEach(attr => {
        const d = attributeToDetail(attr);
        if (d != null) {
          details.push(d);
        }
      });
      return details;
    }
  });

  /**
   * Creates a Detail setup to use the attribute to display the value.
   */
  function attributeToDetail(attr) {
    if (attr.valueType === 'relationship' && attr.source?.attribute?.relationshipType === 'oneToOne') {
      // TODO: check to see if we want to expose this parent
      return {
        name: attr.displayName || StringUtil.camelCaseToTitleCase(attr.name),
        objectType: attr.objectType,
        layout: {
          ...attr.layout
        },
        create: () => {
          let mdl = AttributeDetailModel.create(attr.name, attr.objectType);
          mdl = AttributeDetailModel.setLabel(mdl, attr.displayName || StringUtil.camelCaseToTitleCase(attr.name));
          return mdl;
        }
      };
    }
    return null;
  }
};
export default {
  install
};